<app-page-shell>
    <p-toast position="top-center"></p-toast>

    <app-page-hero
        eyebrow="Payables Controls"
        title="Matching Policies"
        subtitle="Configure two-way and three-way matching rules, receipt requirements, and tolerance thresholds by vendor/category/currency.">
        <div actions>
            <p-button label="Dashboard" icon="pi pi-chart-bar" severity="secondary" [outlined]="true" routerLink="/accounts/enterprise/payables/matching-dashboard"></p-button>
            <p-button label="Refresh" icon="pi pi-refresh" (click)="load()" [loading]="loading"></p-button>
        </div>
    </app-page-hero>

    <div class="policy-grid">
        <app-page-form-section title="Policy" subtitle="Decides whether a vendor bill needs two-way or three-way matching before posting.">
            <div class="form-grid">
                <label>Vendor ID<input pInputText type="number" [(ngModel)]="policy.vendorId"></label>
                <label>Category<input pInputText [(ngModel)]="policy.categoryCode" placeholder="Optional"></label>
                <label>Currency<p-select [options]="currencies" [(ngModel)]="policy.currencyCode" optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"></p-select></label>
                <label>Match Type<p-select [options]="matchTypes" [(ngModel)]="policy.matchType" optionLabel="label" optionValue="value" appendTo="body"></p-select></label>
                <label class="check"><p-checkbox [(ngModel)]="policy.requireReceiptEvidence" [binary]="true"></p-checkbox> Require receipt evidence</label>
                <label class="check"><p-checkbox [(ngModel)]="policy.active" [binary]="true"></p-checkbox> Active</label>
            </div>
            <div class="section-actions">
                <p-button label="Reset" severity="secondary" [outlined]="true" (click)="resetPolicy()"></p-button>
                <p-button label="Save Policy" icon="pi pi-save" (click)="savePolicy()"></p-button>
            </div>
        </app-page-form-section>

        <app-page-form-section title="Tolerance" subtitle="Sets amount and percentage variance limits for invoice total and line components.">
            <div class="form-grid">
                <label>Vendor ID<input pInputText type="number" [(ngModel)]="tolerance.vendorId"></label>
                <label>Category<input pInputText [(ngModel)]="tolerance.categoryCode" placeholder="Optional"></label>
                <label>Currency<p-select [options]="currencies" [(ngModel)]="tolerance.currencyCode" optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"></p-select></label>
                <label>Component<p-select [options]="components" [(ngModel)]="tolerance.matchComponent" optionLabel="label" optionValue="value" appendTo="body"></p-select></label>
                <label>Amount tolerance<p-inputNumber [(ngModel)]="tolerance.amountTolerance" mode="decimal" [minFractionDigits]="2"></p-inputNumber></label>
                <label>Percent tolerance<p-inputNumber [(ngModel)]="tolerance.percentageTolerance" suffix="%" mode="decimal" [minFractionDigits]="2"></p-inputNumber></label>
                <label class="check"><p-checkbox [(ngModel)]="tolerance.active" [binary]="true"></p-checkbox> Active</label>
            </div>
            <div class="section-actions">
                <p-button label="Reset" severity="secondary" [outlined]="true" (click)="resetTolerance()"></p-button>
                <p-button label="Save Tolerance" icon="pi pi-save" (click)="saveTolerance()"></p-button>
            </div>
        </app-page-form-section>
    </div>

    <app-page-data-panel title="Policies" [resultText]="policies.length + ' policies'">
        <p-table [value]="policies" [loading]="loading" responsiveLayout="scroll">
            <ng-template pTemplate="header"><tr><th>Vendor</th><th>Category</th><th>Currency</th><th>Type</th><th>Receipt</th><th>Status</th><th></th></tr></ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{ row.vendorId || 'Any' }}</td>
                    <td>{{ row.categoryCode || 'Any' }}</td>
                    <td>{{ row.currencyCode || 'Any' }}</td>
                    <td>{{ row.matchType }}</td>
                    <td>{{ row.requireReceiptEvidence ? 'Required' : 'Optional' }}</td>
                    <td><p-tag [value]="row.active ? 'ACTIVE' : 'INACTIVE'" [severity]="row.active ? 'success' : 'secondary'"></p-tag></td>
                    <td><p-button label="Edit" icon="pi pi-pencil" size="small" [outlined]="true" (click)="editPolicy(row)"></p-button></td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>

    <app-page-data-panel title="Tolerances" [resultText]="tolerances.length + ' tolerances'">
        <p-table [value]="tolerances" [loading]="loading" responsiveLayout="scroll">
            <ng-template pTemplate="header"><tr><th>Vendor</th><th>Category</th><th>Currency</th><th>Component</th><th>Amount</th><th>Percent</th><th>Status</th><th></th></tr></ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{ row.vendorId || 'Any' }}</td>
                    <td>{{ row.categoryCode || 'Any' }}</td>
                    <td>{{ row.currencyCode || 'Any' }}</td>
                    <td>{{ row.matchComponent }}</td>
                    <td>{{ row.amountTolerance | number:'1.4-4' }}</td>
                    <td>{{ row.percentageTolerance | number:'1.4-4' }}%</td>
                    <td><p-tag [value]="row.active ? 'ACTIVE' : 'INACTIVE'" [severity]="row.active ? 'success' : 'secondary'"></p-tag></td>
                    <td><p-button label="Edit" icon="pi pi-pencil" size="small" [outlined]="true" (click)="editTolerance(row)"></p-button></td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
